import apiClient from './client'

export const notificationsApi = {
  getNotifications: async () => {
    const response = await apiClient.get('/notifications')
    return response.data
  },

  markAsRead: async (id) => {
    const response = await apiClient.post(`/notifications/${id}/read`)
    return response.data
  },

  deleteNotification: async (id) => {
    const response = await apiClient.delete(`/notifications/${id}`)
    return response.data
  },
}

